import { render, staticRenderFns } from "./saveCancelBtn.vue?vue&type=template&id=2f72190a&"
import script from "./saveCancelBtn.vue?vue&type=script&lang=js&"
export * from "./saveCancelBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports